import { useContext } from "react";
import { FormContext } from "../../context/FormContext";
import { ToolContext } from "../../context/ToolContext";

export const useAsset = () => {
  const { formState } = useContext(FormContext);
  const { toolState } = useContext(ToolContext);

  const { clientSettings } = formState;
  const { mode, clickedAsset, ringfencedFiltered } = toolState;

  const isAssetSelected = (assetId: string): boolean => {
    return (clickedAsset as { id?: string })?.id === assetId;
  };

  const isAssetRingfenced = (assetId: string): boolean => {
    return ringfencedFiltered.some((p) => p.id === assetId);
  };

  const canMoveObjects = (assetId: string) => {
    if (!clientSettings.features.EditModeEnabled) {
      return false;
    }
    if (mode === "select-results") {
      return false;
    }
    if (["select", "re-shape"].includes(mode)) {
      return true;
    }
    if (mode === "select-group" && ringfencedFiltered.some((p) => p.id === assetId)) {
      return true;
    }
    return false;
  };
  return { canMoveObjects, isAssetSelected, isAssetRingfenced };
};
